// Authentication API endpoints

import { baseApi } from '../baseApi';
import { API_ENDPOINTS } from '@/utils/constants';
import type { SaveUserAccountResponse, SaveUserAccountMutationParams } from './types';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // Verify token
    verifyToken: builder.query<{ valid: boolean }, void>({
      query: () => API_ENDPOINTS.AUTH.VERIFY,
    }),

    // Request password reset
    requestPasswordReset: builder.mutation<
      { message: string },
      { email: string }
    >({
      query: (data) => ({
        url: API_ENDPOINTS.AUTH.RESET_PASSWORD,
        method: 'POST',
        body: data,
      }),
    }),

    // Save user account after login
    saveUserAccount: builder.mutation<SaveUserAccountResponse, SaveUserAccountMutationParams>({
      query: ({ data, token }) => ({
        url: API_ENDPOINTS.USER.ACCOUNT,
        method: 'PUT',
        body: data,
        headers: token ? { 'Authorization': `Bearer ${token}` } : undefined,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useVerifyTokenQuery,
  useRequestPasswordResetMutation,
  useSaveUserAccountMutation,
} = authApi;
